import { NoteSubCategory, TargetAudience } from ".";

export class Note {
    public id: number;
    public createdBy: string;
    public createdUtcDate: Date;
    public noteSubCategoryId: number;
    public noteContent: string;
    public noteSubCategory: NoteSubCategory;
    public targetAudiences: TargetAudience[];
}